
  import { defineComponent, PropType } from 'vue';
  import { mapActions, mapGetters } from 'vuex';

  import { TFilterSelect, TFilterTreeSelect } from '@/common/components/redesigned/Filter/types/filter';
  import { MenuModes } from '@/common/components/redesigned/TreeMultiselect/types';
  import { TDictionary } from '@/common/types/dictionary';
  import { TSelectOption } from '@/common/types/select';

  import {
    INDICATOR_TYPE_FILTER_OPTIONS,
    PRODUCTS_TRADE_DIRECTION_FILTER_OPTIONS,
    SELECT_TYPE_FILTER_OPTIONS,
  } from '../../constants/options';
  import { COUNTRIES_LEVEL_EVENTS_LABELS } from '../../constants/tree';
  import { VED_COMMON_ACTIONS_NAME, VED_COMMON_GETTERS_NAME } from '../../store/vedCommon/name';
  import { TForeignTradeByProductsFilter } from '../../types/foreign-trade-by-products';
  import { generateCodeProductOptions } from '../../utils/codeProductOptions';
  import { yearMonthPeriodTreeFilterConfig } from '../../utils/filter';
  import FilterDetailsVed from '../common/FilterDetailsVed.vue';
  import FilterFactoryVed from '../common/FilterFactoryVed.vue';

  export default defineComponent({
    name: 'ForeignTradeByProductsFilter',
    components: {
      FilterDetailsVed,
      FilterFactoryVed,
    },
    emits: {
      searchFilter: (filter: Partial<TForeignTradeByProductsFilter>) => filter,
      updateFilter: (filter: Partial<TForeignTradeByProductsFilter>) => filter,
    },
    props: {
      defaultFilter: {
        type: Object as PropType<TForeignTradeByProductsFilter>,
        required: true,
      },
      readonlyPermissionCode: {
        type: Number,
      },
    },
    created() {
      this.searchCountriesTree();
      this.searchRegionsRfTree();
    },
    computed: {
      ...mapGetters({
        getCountriesTree: VED_COMMON_GETTERS_NAME.getCountriesTree,
        getRegionsRfTree: VED_COMMON_GETTERS_NAME.getRegionsRfTree,
      }),
      getFiltersConfig(): [
        TFilterTreeSelect,
        TFilterTreeSelect,
        TFilterTreeSelect,
        TFilterSelect<TSelectOption>,
        TFilterSelect<TSelectOption>,
        TFilterSelect<TDictionary>,
        TFilterSelect<TSelectOption>,
      ] {
        return [
          yearMonthPeriodTreeFilterConfig,
          {
            type: 'tree-select',
            label: 'Субъект РФ',
            options: this.getRegionsRfTree,
            vModel: 'regionsRf',
            required: true,
            isSingleMode: true,
            menuMode: MenuModes.COMBINED_MODAL,
          },
          {
            type: 'tree-select',
            label: 'Страна-партнер',
            options: this.getCountriesTree,
            vModel: 'countries',
            required: true,
            isSingleMode: true,
            levelEventsLabels: COUNTRIES_LEVEL_EVENTS_LABELS,
            menuMode: MenuModes.COMBINED_MODAL,
          },
          {
            type: 'select',
            label: 'Направление торговли',
            options: PRODUCTS_TRADE_DIRECTION_FILTER_OPTIONS,
            vModel: 'tradeDirectionId',
            valueProp: 'value',
            labelProp: 'label',
            required: true,
          },
          {
            type: 'select',
            label: 'Тип выборки',
            options: SELECT_TYPE_FILTER_OPTIONS,
            vModel: 'selectTypeId',
            valueProp: 'value',
            labelProp: 'label',
            required: true,
          },
          {
            type: 'select',
            label: 'Знаков в коде товара',
            options: generateCodeProductOptions(),
            vModel: 'amountSigns',
            valueProp: 'id',
            labelProp: 'name',
            required: true,
          },
          {
            type: 'select',
            label: 'Показатели',
            options: INDICATOR_TYPE_FILTER_OPTIONS,
            vModel: 'indicatorTypeId',
            valueProp: 'value',
            labelProp: 'label',
            required: true,
          },
        ];
      },
    },
    methods: {
      ...mapActions({
        searchCountriesTree: VED_COMMON_ACTIONS_NAME.searchCountriesTree,
        searchRegionsRfTree: VED_COMMON_ACTIONS_NAME.searchRegionsRfTree,
      }),
      searchFilter(filter: Partial<TForeignTradeByProductsFilter>) {
        this.$emit('searchFilter', filter);
      },
      updateFilter(filter: Partial<TForeignTradeByProductsFilter>) {
        this.$emit('updateFilter', filter);
      },
    },
  });
